import React, { useEffect, Suspense } from 'react';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import { lazy } from '@loadable/component';
import styled from 'styled-components';
import PrerenderSafeLazyLoad from 'components/PrerenderSafeLazyLoad';

import { getBlogBaseStack } from 'features/blog/actions';
import { setTopNavColorLight } from 'features/navigation/header/actions';

import CircularProgress from '@material-ui/core/CircularProgress';

import BlogHeader from 'views/Blog/elements/BlogHeader';
import BlogFooter from 'views/Blog/elements/BlogFooter';

const BlogDetail = lazy(() => import('views/Blog/Detail'));
const BlogPosts = lazy(() => import('views/Blog/Posts'));
const BlogCollectionDetail = lazy(() =>
  import('views/Blog/Collections/Detail')
);
const BlogCollections = lazy(() => import('views/Blog/Collections'));
const BlogHome = lazy(() => import('views/Blog/Home'));

const BlogMain = styled.main`
  min-height: 100vh;
`;

const BlogBase = React.memo(
  ({ stack, setTopNavColorLight, getBlogBaseStack }) => {
    useEffect(() => {
      getBlogBaseStack();
      setTopNavColorLight();
    }, [getBlogBaseStack, setTopNavColorLight]);

    return stack ? (
      <Suspense fallback={<CircularProgress />}>
        <BlogHeader {...stack.header} />
        <BlogMain>
          <Switch>
            <Route
              path="/blog/category/:categorySlug"
              component={BlogPosts}
              exact
            />
            <Route
              path="/blog/tag/:tagType/:tagSlug?"
              component={BlogPosts}
              exact
            />
            <Route
              path="/blog/collections/:collectionSlug"
              component={BlogCollectionDetail}
              exact
            />
            <Route path="/blog/collections" component={BlogCollections} exact />
            <Route path="/blog/:postSlug" component={BlogDetail} exact />
            <Route path="/blog" component={BlogHome} exact />
          </Switch>
        </BlogMain>
        <PrerenderSafeLazyLoad height={300}>
          <BlogFooter {...stack.footer} />
        </PrerenderSafeLazyLoad>
      </Suspense>
    ) : null;
  }
);

export default connect(
  state => ({
    stack: state.blogBase.stack
  }),
  { getBlogBaseStack, setTopNavColorLight }
)(BlogBase);
